import * as React from 'react';
const context = React.createContext(undefined);
context.displayName = 'LegalsContext';
export default context;
